module.exports = __webpack_public_path__ + "a3e3d4db11b9a6e2cc44a06193b1e2af.svg";